import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as MdIcons from 'react-icons/md';
import * as BiIcons from 'react-icons/bi';
import * as TbIcons from 'react-icons/tb';

const SafeIcon = ({ icon, name, lib = 'fi', ...props }) => {
  let IconComponent = icon;
  
  if (!IconComponent && name) {
    if (lib === 'fi') IconComponent = FiIcons[`Fi${name}`];
    else if (lib === 'md') IconComponent = MdIcons[`Md${name}`];
    else if (lib === 'bi') IconComponent = BiIcons[`Bi${name}`];
    else if (lib === 'tb') IconComponent = TbIcons[`Tb${name}`];
  }

  // Fallback icon
  if (!IconComponent) {
    IconComponent = FiIcons.FiAlertTriangle;
  }

  return React.createElement(IconComponent, props);
};

export default SafeIcon;